import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchWarehouse(serviceProviderId, warehouseId) {
    return RequesterV1.get(
      `service_provider/warehouse/movements/${serviceProviderId}/show_warehouse/${warehouseId}`
    );
  },

  fetchInventoryItems(serviceProviderId, warehouseId) {
    return RequesterV1.get(
      `service_provider/warehouse/movements/${serviceProviderId}/manage_inventory_movements/fetch_inventory_items/${warehouseId}`
    );
  },

  fetchSuppliers(serviceProviderId, warehouseId) {
    return RequesterV1.get(
      `service_provider/warehouse/movements/${serviceProviderId}/manage_inventory_movements/fetch_suppliers/${warehouseId}`
    );
  },

  fetchInventoryMovement(serviceProviderId, warehouseId, inventoryMovementId) {
    return RequesterV1.get(
      `service_provider/warehouse/movements/${serviceProviderId}/manage_inventory_movements/fetch_inventory_movement/${warehouseId}/${inventoryMovementId}`
    );
  },

  create(serviceProviderId, warehouseId, inventory_movement) {
    return RequesterV1.post(
      `service_provider/warehouse/movements/${serviceProviderId}/manage_inventory_movements/create/${warehouseId}`,
      { inventory_movement }
    );
  },

  update(serviceProviderId, warehouseId, inventoryMovementId, inventory_movement) {
    return RequesterV1.post(
      `service_provider/warehouse/movements/${serviceProviderId}/manage_inventory_movements/update/${warehouseId}/${inventoryMovementId}`,
      { inventory_movement }
    );
  },

  destroy(serviceProviderId, warehouseId, inventoryMovementId) {
    return RequesterV1.delete(
      `service_provider/warehouse/movements/${serviceProviderId}/manage_inventory_movements/destroy/${warehouseId}/${inventoryMovementId}`,
    );
  }
};
